import React, { Component } from 'react'
import 'lazysizes'
import SEO from '../../components/core/SEO'
import darkTheme from '../../constants/themeConstants/darkTheme'
import Header from '../../components/Header'
import Footer from '../../components/core/Footer'
import LandingPage from '../../components/Events/LandingPage'
import EventsDescriptionSection from '../../components/Events/EventsDescriptionSection'
import TestimonialSlick from '../../components/Events/TestimonialSlick'
import IbCricketHostingSection from '../../components/Events/IbCricketHostingSection'
import bookNowConstants from '../../constants/bookNowFormConstants'

class Events extends Component {
  constructor(props) {
    super(props)
    this.state = {
      glsLoaded: false
    }
  }

  initMap = () => {
    this.setState({
      glsLoaded: true
    })
  }

  loadGooglePlacesScript() {
    try {
      window.initMap = this.initMap
      const gmapScriptEl = document.createElement(`script`)
      gmapScriptEl.src = bookNowConstants.GOOGLE_SCRIPT_URL
      document
        .querySelector(`body`)
        .insertAdjacentElement(`beforeend`, gmapScriptEl)
    } catch (error) {
      console.log(error)
    }
  }

  componentDidMount() {
    if (!window.google) {
      this.loadGooglePlacesScript()
    }
    if (window.google) {
      this.initMap()
    }
  }
  render() {
    const {
      headerPropsData,
      footerProps,
      data,
      isBookNowSlotOpened,
      bookNowModalData
    } = this.props
    const { glsLoaded } = this.state
    const { eventsHostedSectionData: { edges: eventsHostedSectionData },applyForFranchiseData:{edges:formData} } = data
    const eventsHostedSectionDataProps =
      eventsHostedSectionData[0].node.frontmatter
    const {
      eventsLandingSection,
      eventsHostedAtHeader,
      eventsSection,
      testimonials,
      seoData
    } = eventsHostedSectionDataProps
    return (
      <div>
        <SEO SEOData={seoData} />
        <Header
          hideLogoByDefault
          formData={formData}
          headerPropsData={headerPropsData}
          isBookNowSlotOpened={isBookNowSlotOpened}
          bookNowModalData={bookNowModalData}
        />
        <LandingPage eventsLandingSection={eventsLandingSection} />
        <IbCricketHostingSection eventsHostedAtHeader={eventsHostedAtHeader} />
        <EventsDescriptionSection
          eventsSection={eventsSection}
          glsLoaded={glsLoaded}
        />
        <TestimonialSlick testimonials={testimonials} />
        <Footer {...footerProps} theme={darkTheme.footerSection} />
      </div>
    )
  }
}
export default Events

// eslint-disable-next-line
export const graphqlQuery = graphql`
  query EventsPageQuery {
    eventsHostedSectionData: allMarkdownRemark(
      filter: { fileAbsolutePath: { regex: "/content/events/events-page/" } }
      sort: { fields: [frontmatter___order], order: ASC }
    ) {
      edges {
        node {
          frontmatter {
            title
            eventsLandingSection {
              title
              titleDescription
              buttonText
              buttonRedirectUrl
              backgroundImageUrl
              mobileBackgroundImageUrl
            }
            eventsHostedAtHeader {
              eventsHostedAtHeaderHeading
              hostedList {
                imageUrl
              }
              footerDescription
              bottomDescription
            }
            eventsSection {
              eventsSectionId
              eventsList {
                eventId
                title
                description
                mainImage
                mobileImage
                buttonText
              }
            }
            testimonials {
              testimonialsHeading
              testimonialsList {
                testimonialId
                imageUrl
                description
                name
                country
              }
            }
            seoData {
              title
              description
              ogTitle
              ogUrl
              ogImage
              ogDescription
              ogType
              ogSiteName
              twitterCard
              twitterUrl
              twitterSite
              twitterTitle
              twitterDescription
              twitterImage
              schemaData
              canonicalUrl
              isRobotsTextEnabled
            }
          }
        }
      }
    }
    applyForFranchiseData: allMarkdownRemark(
      filter: {
        fileAbsolutePath: { regex: "/content/viu/ibc-apply-franchise-data/" }
      }
    ) {
      edges {
        node {
          frontmatter {
            title
            pageHeading
            pageSubHeading
            formHeading
            nameFieldPlaceholder
            emailFieldPlaceholder
            phoneNumberFieldPlaceholder
            occupationFieldPlaceholder
            locationFieldPlaceHolder
            ctaButtonText
            thankYouTextOne
            thankYouTextTwo
            backgroundImage
            mobilBackgroundImage
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/events-and-parties/index.js